// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"8610bb48","498":"873b08c1","513":"e1ed8507","703":"050d2ca2","787":"08abe8f7"}[chunkId] + ".chunk.js";
};